import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        //? for debug: console.log(payload);
        let result = await apiClient(config).apiMethod({
            method: 'Feedback',
            args: {
                name: payload.name,
                email: payload.email,
                comments: payload.comments,
            },
        });

        return result;
    };
};
